import ExecuteApiCall from './apiClient';

export function fetchAllCountries(locale) {
  return ExecuteApiCall('get', 'api/v2/countries', { locale });
}
